import React, {useState,useEffect} from "react";
import "./TableInfoHeader.scss";
import classNames from 'classnames';

import TableInfoCell from "components/uiComponents/TableInfoCell";
import IndeterminateCheckbox from "components/uiComponents/IndeterminateCheckbox";
import { indeterminateCheckboxTypes as checkboxTypes } from "components/uiComponents/IndeterminateCheckbox";

import { ReactComponent as ArrowSortIcon } from "static/icons/arrow-sort.svg";
import { changeCheckbox, changeColumnCheckbox } from "../../../store/actions/table";
import { useDispatch, useSelector } from "react-redux";


const TableInfoHeader = ({
  header,
  sorting,
  onSortChange,
  table
}) => {

  const dispatch = useDispatch();

  const { selectedOptions, tabs } = useSelector(state => state.table);

  const [statusCheckboxes, setStatusCheckboxes] = useState(null);

  useEffect(() => {

    let resultObj = {}

    table.header.forEach((headerName) => {
      let count = 0;
      selectedOptions.forEach((option) => {
        if(option.id.includes(headerName)) {
          count++;
        }
      })
      resultObj = {...resultObj, [headerName]: table.lineElements.length === count && table.lineElements.length !== 0? checkboxTypes.checked : count === 0 ? checkboxTypes.unchecked : checkboxTypes.indeterminate};
    })

    setStatusCheckboxes(resultObj);
  }, [selectedOptions])

  const onChangeCheckbox = (index, name) => {

    const selectedOptions = [];
    const checkedHeader = statusCheckboxes[name] === (checkboxTypes.checked || checkboxTypes.indeterminate) ? true : false;

    table.lineElements.forEach((line, indexLine) => {

      const lineElements = table.lineElements[indexLine];
      const id = `${table.lines[indexLine][0]}/${table.header[index]}/${table.lines[indexLine][index]}`;
      const checked = true;
      let missingProperties = table.missingProperties[indexLine][index];

      selectedOptions.push({checked: checked, lineElements, id, missingProperties})
    })

    dispatch(changeColumnCheckbox({selectedOptions, name, checkedHeader}));

    statusCheckboxes[name] ? setStatusCheckboxes(checkboxTypes.checked) : setStatusCheckboxes(checkboxTypes.unchecked);
  }

  const headerUpd = header?.map(item => {
    return {
      name: item,
      label: item.split('(')[0].trim(),
    }
  });
  const [...rest] = headerUpd ? headerUpd : [];

  const handleSortClick = (name) => {
    onSortChange(name);
  };

  const handleClickCheckbox = (index,name) => {
    onChangeCheckbox(index,name);
  }

  return (
    <div className="table-info-header">
      <div className="table-info-header__row">

        {
          rest.map((el, index) => {
            const name = el.name;
            const handleInsideSortClick = () => {
              handleSortClick(name);
            };

            return (
                statusCheckboxes &&
                <TableInfoCell key={`tableheader${name}-${index}`}>
                <div className="table-info-header__cell_content">
                  <IndeterminateCheckbox
                    onChange={() => handleClickCheckbox(index,name) }
                    status={statusCheckboxes[name]}
                  />
                  <div
                    onClick={handleInsideSortClick}
                    className="table-info-header__cell_sort-wrapper"
                  >
                    <div
                      className={classNames({
                        "table-info-header__cell_title": true,
                        "table-info-header__cell_title--active": sorting?.[name]?.isActive,
                      })}
                    >
                      {el.label}
                    </div>

                    <div className="table-info-header__sort">
                      <ArrowSortIcon
                        className={classNames({
                          'table-info-header__sort-icon': true,
                          'table-info-header__sort-icon--active': sorting?.[name]?.isActive,
                          'table-info-header__sort-icon--asc': !sorting?.[name]?.isDescending,
                        })}
                      />
                    </div>
                  </div>
                </div>
              </TableInfoCell>
            )
        })}
      </div>
    </div>
  );
};

export default TableInfoHeader;
